import axiosInstance from "@/axios";
import Swal from 'sweetalert2';

const state = { 
    jdsData: null,
    jdsCount: null,

    ngtgData: null,
    ngtgCount: null,

    gtgData: null,
    gtgCount: null,

    cvsData: null,
    cvsCount: null, 

    pipelineData: null,
    pipelineCount: null,

    canceledData: null,
    canceledCount: null, 
};

const mutations = {
    SET_DASHBOARD_DATA(state, data) { 
        state.jdsData = data.jds.data;
        state.jdsCount = data.jds.count;
        
        state.ngtgData = data.ngtg.data;
        state.ngtgCount = data.ngtg.count;

        state.gtgData = data.gtg.data;
        state.gtgCount = data.gtg.count;

        state.cvsData = data.cvs.data;
        state.cvsCount = data.cvs.count; 

        state.pipelineData = data.pipeline.data;
        state.pipelineCount = data.pipeline.count;
    
        state.canceledData = data.canceled.data;
        state.canceledCount = data.canceled.count;
    },
};

const actions = { 
    async fetchDashboardData({ commit }) {
        try { 
            const response = await axiosInstance({ requiresAuth: true }).get('/api/v1/portal/dashboard');
            commit('SET_DASHBOARD_DATA', response.data.data);
        } catch (error) {  
            const errorMessage = error.response ? error.response.data.message : "Ein unerwarteter Fehler ist aufgetreten.";
            Swal.fire("Da ist etwas schiefgelaufen!", errorMessage, "error");
        }  
    },

    async sendInterested({ uuid, vacancyId, comment }) {
        try { 
            await axiosInstance({ requiresAuth: true }).post(`/api/v1/portal/candidate-vacancies/${uuid}/vacancies/${vacancyId}/gtg`, { comment: comment }); 
    
            Swal.fire("Erfolgreich gesendet!", '', "success").then(() => {   
              this.fetchDashboardData();
            });     
        } catch (error) {
            const errorMessage = error.response ? error.response.data.message : "Ein unerwarteter Fehler ist aufgetreten.";
            Swal.fire("Da ist etwas schiefgelaufen!", errorMessage, "error");
        }
    },

    async sendNotInterested({ uuid, vacancyId, comment }) {
        try { 
            await axiosInstance({ requiresAuth: true }).post(`/api/v1/portal/candidate-vacancies/${uuid}/vacancies/${vacancyId}/ngtg`, { comment: comment }); 
    
            Swal.fire("Erfolgreich gesendet!", '', "success").then(() => {   
              this.fetchDashboardData();
            });     
        } catch (error) {
            const errorMessage = error.response ? error.response.data.message : "Ein unerwarteter Fehler ist aufgetreten.";
          Swal.fire("Da ist etwas schiefgelaufen!", errorMessage, "error");
        }
    },
};

const getters = { 
    jdsData: (state) => state.jdsData,
    jdsCount: (state) => state.jdsCount,

    ngtgData: (state) => state.ngtgData,
    ngtgCount: (state) => state.ngtgCount,

    gtgData: (state) => state.gtgData,
    gtgCount: (state) => state.gtgCount,

    cvsData: (state) => state.cvsData,
    cvsCount: (state) => state.cvsCount,

    pipelineData: (state) => state.pipelineData,
    pipelineCount: (state) => state.pipelineCount,
 
    canceledData: (state) => state.canceledData,
    canceledCount: (state) => state.canceledCount,
};

export default {
    namespaced: true,  
    state,
    mutations,
    actions,
    getters,
};
